export default "__VITE_ASSET__D7YDtMfN__"